import React from 'react';
import { Box, Typography } from '@mui/material';
import { MinigameType } from '../../shared/events';
import CartoonButton from '../CartoonButton.component';

interface GameDef {
  type: MinigameType;
  icon: string;
  label: string;
  color: string;
}

const GAMES: GameDef[] = [
  { type: 'closest-number', icon: '🎯', label: 'Closest',  color: '#e91e63' },
  { type: 'number-question', icon: '🔢', label: 'Numbers',  color: '#9c27b0' },
  { type: 'pick-a-side',     icon: '⚖️', label: 'Sides',    color: '#3f51b5' },
  { type: 'fastest-tap',     icon: '⚡', label: 'Tap!',     color: '#ff9800' },
  { type: 'type-the-word',   icon: '⌨️', label: 'Type',     color: '#009688' },
  { type: 'vote-boost',      icon: '👑', label: 'Vote',     color: '#8bc34a' },
  { type: 'team-red-blue',   icon: '🔴🔵', label: 'Teams',  color: '#f44336' },
];

interface Props {
  onLaunch: (gameType: MinigameType) => void;
}

const MinigameBar: React.FC<Props> = ({ onLaunch }) => (
  <Box
    sx={{
      display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'center',
      px: 2, py: 1,
      background: 'rgba(0,0,0,0.12)',
      borderRadius: '16px',
      border: '2px solid rgba(255,255,255,0.15)',
    }}
  >
    <Typography
      sx={{
        width: '100%', textAlign: 'center',
        fontFamily: '"Comic Sans MS", cursive', fontWeight: 'bold',
        color: 'rgba(255,255,255,0.7)', fontSize: '0.7rem', mb: 0.5,
      }}
    >
      MINI-GAMES
    </Typography>
    {GAMES.map(game => (
      <CartoonButton
        key={game.type}
        variant="contained"
        onClick={() => onLaunch(game.type)}
        sx={{
          background: game.color,
          minWidth: 0, px: 1.5, height: 36, fontSize: '0.75rem',
          boxShadow: `0 3px 0 rgba(0,0,0,0.4)`,
          '&:hover': { transform: 'translateY(-3px)', boxShadow: `0 6px 0 rgba(0,0,0,0.4)` },
        }}
      >
        {game.icon} {game.label}
      </CartoonButton>
    ))}
  </Box>
);

export default MinigameBar;
